import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';
import { OrganizationData, ToneModel } from '../../../shared/models/organization-data.model';

@Injectable()
export class FormAppService {
    private organization: ReplaySubject<OrganizationData> = new ReplaySubject<OrganizationData>(1);
    private workingScheduleForm: ReplaySubject<FormGroup> = new ReplaySubject<FormGroup>(1);

    getOrganization(): Observable<OrganizationData> {
        return this.organization.asObservable();
    }

    setOrganization(organization: OrganizationData): void {
        this.organization.next(organization);
    }

    hasRelevantChangeInBranding(
        pastData: OrganizationData | undefined,
        currentData: OrganizationData | undefined
    ): boolean {
        if (!pastData || !currentData) return false;

        const colorsToCompare = [
            'primaryColor',
            'secondaryColor',
            'successColor',
            'errorColor',
            'warnColor',
            'infoColor',
        ];

        const tonesToCompare = [
            'primaryTones',
            'secondaryTones',
            'successTones',
            'errorTones',
            'warnTones',
            'infoTones',
        ];

        const hasColorChanges = colorsToCompare.some((key) => pastData[key] !== currentData[key]);

        const hasToneChanges = tonesToCompare.some((toneKey) => {
            const pastTone = pastData[toneKey] as ToneModel | undefined;
            const currentTone = currentData[toneKey] as ToneModel | undefined;

            if (!pastTone && !currentTone) return false;
            if (!pastTone || !currentTone) return true;

            return (
                pastTone.lightTone !== currentTone.lightTone ||
                pastTone.primaryTone !== currentTone.primaryTone ||
                pastTone.darkTone !== currentTone.darkTone
            );
        });
        const hasRelevantChanges = hasColorChanges || hasToneChanges;
        return hasRelevantChanges;
    }

    getWorkingScheduleForm(): Observable<FormGroup> {
        return this.workingScheduleForm.asObservable();
    }

    setWorkingScheduleForm(form: FormGroup): void {
        this.workingScheduleForm.next(form);
    }
}
